import React from 'react'
import PropTypes from 'prop-types'

const Button = props => {
  const className = props.wait ? `${props.className} ${props.className}-wait` : props.className

  const onClick = () => {
    if (props.onClick) props.onClick({ name: props.name, data: PropTypes.data })
  }

  return (
    <div className={className} onClick={onClick}>
      {props.children}
    </div>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  data: PropTypes.any,
  children: PropTypes.any,
  wait: PropTypes.any,
  onClick: PropTypes.func
}

Button.defaultProps = {
  wait: false
}

export default Button
